export default "__VITE_ASSET__a66eb333__"